import { render, staticRenderFns } from "./bank-account-form.vue?vue&type=template&id=074d84a4&scoped=true&"
import script from "./bank-account-form.vue?vue&type=script&lang=js&"
export * from "./bank-account-form.vue?vue&type=script&lang=js&"
import style0 from "./bank-account-form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bank-account-form.vue?vue&type=style&index=1&id=074d84a4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d84a4",
  null
  
)

export default component.exports